// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3lGOq","boxTitle":"Qualiphy_boxTitle__1dROz","box":"Qualiphy_box__SeI8z","toggleWrap":"Qualiphy_toggleWrap__EUojI"};